<div
  class="ete-dropdown-main-wrapper"
  [ngClass]="[
    disabled ? 'ete-dropdown-icon--disable' : '',
    class,
    size === 'lg' ? 'ete-dropdown-lg' : 'ete-dropdown-sm'
  ]"
>
  <button
    nz-popover
    nzOverlayClassName="ete-dropdown-overlay"
    nzPopoverTrigger="click"
    [nzPopoverVisible]="isPopoverVisible"
    [nzPopoverContent]="exportOptionsTemplate"
    nzPopoverPlacement="bottomRight"
    (nzPopoverVisibleChange)="handlePopupVisibilityChange($event)"
    class="va-button va-icon-button va-button-outline va-button-outline--primary"
    [ngClass]="[
      isPopoverVisible ? 'va-button--active' : '',
      disabled ? 'va-button--disabled' : ''
    ]"
    [title]="title"
    [nzPopoverBackdrop]="true"
  >
    <va-icon
      *ngIf="!isExportInProgress; else exportLoading"
      size="small"
      name="file-excel"
      class="va-button-icon"
      [title]="title"
    >
    </va-icon>
  </button>
  <ng-template #exportOptionsTemplate>
    <div>
      <div
        *ngFor="let item of optionList"
        (click)="handleListItemClick(item.id)"
        class="ete-dropdown-list-item"
        [ngClass]="{ 'ete-dropdown-list-item--disabled': item.disabled }"
      >
        {{ item.label }}
      </div>
    </div>
  </ng-template>
  <ng-template #exportLoading>
    <ng-template #indicatorTemplate>
      <va-icon
        [isFontAwesome]="true"
        size="small"
        [name]="faSpinner"
        [spin]="true"
        class="ete-spinner-icon"
      ></va-icon>
    </ng-template>
    <nz-spin nzSimple [nzIndicator]="indicatorTemplate"> </nz-spin>
  </ng-template>
</div>
